import { convertEWSFolderIdToRestFolderId } from 'owa-favorites';
import { FavoriteFolderData, OutlookFavoriteServiceDataType } from 'owa-favorites-types';
import { Folder, getEffectiveFolderDisplayName } from 'owa-folders';

export function createInitialFavoriteFolderData(
    favoriteId: string,
    folder: Folder,
    isAddDefault: boolean
): FavoriteFolderData {
    return {
        folderId: folder.FolderId.Id,
        treeType: 'favorites',
        type: 'folder',
        favoriteId: favoriteId,
        displayName: getEffectiveFolderDisplayName(folder),
        client: isAddDefault ? 'MigrateDefault' : 'OWA',
    };
}

export function createAddFavoriteFolderServicePayload(
    folder: Folder,
    isAddDefault: boolean
): OutlookFavoriteServiceDataType {
    return {
        Type: 'folder',
        DisplayName: getEffectiveFolderDisplayName(folder),
        SingleValueSettings: [
            {
                Key: 'FolderId',
                Value: convertEWSFolderIdToRestFolderId(folder.FolderId.Id),
            },
        ],
        Client: isAddDefault ? 'MigrateDefault' : 'OWA',
    };
}
